import UtLogo from "../../Assets/Images/Ut-Trans.png";
import NlLogo from "../../Assets/Images/Nl-Trans.png";
import ParkLogo from "../../Assets/Images/park.png";
import { useEffect, useState } from "react";
import { BsCcCircle, BsClock, BsPerson, BsPostcard, BsSquare } from "react-icons/bs";
import { MdChevronLeft, MdEmail, MdLocationPin, MdPhone } from "react-icons/md";
import './Style.css';

export default function Footer() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {width < 768 && (
        <div className="p-4 w-100 mobile-navbar glass-footer">
          <div className="d-flex flex-row justify-content-around">
            <a href="https://ble.ir/ibinsina_support">
              <MdPhone className='text-primary' size="25px"/>
            </a>
            <a href="https://ble.ir/ibinsina_support">
              <MdEmail className='text-primary' size="25px"/>
            </a>
            <a href="https://panel.ibinsina.com">
              <BsPerson className='text-primary' size="25px"/>
            </a>
          </div>
        </div>
      )}

      <div className='bg-light p-4 w-100 glass-footer' style={{ bottom:"0px" }} id="about-us">
        <div className='container-fluid'>
          <div className='row justify-content-between align-items-start'>

            {/* تماس */}
            <div className='col-md-3 p-4'>
              <p className="bold text-muted">راه های تماس</p>
              <hr/>
              <p className="brand-p">
                <span className="m-2 text-primary"><MdLocationPin/></span>
                <span className="bold">آدرس : </span>
                <span className="text-muted">
                  تهران، اقدسیه ، جنب پژوهشگاه دانشهای بنیادی، خیابان شهید ابوالفضل صمیع، پلاک صفر طبقه همکف  
                </span>
              </p>
              <p className="brand-p">
                <span className="m-2 text-primary"><BsPostcard/></span>
                <span className="bold">کد پستی : </span>
                <span className="text-muted">۱۹۵۶۸۳۶۴۸۸</span>
              </p>
              <p>
                <span className="m-2 text-primary"><MdPhone/></span>
                <span className="bold">تلفن : </span>
                <a href="tel:+982126318623" className="brand-a text-muted">۰۲۱۲۶۳۱۸۶۲۳</a>
              </p>
              <p className="brand-p">
                <span className="m-2 text-primary"><MdEmail/></span>
                <span className="bold">ایمیل : </span>
                <a href="mailto:ibinsina.com@gmail.com" className="brand-a text-muted">info@ibinsina.com</a>
              </p>
              <p className="brand-p">
                <span className="m-2 text-primary"><BsClock/></span>
                <span className="bold">ساعات کاری : </span>
                <span className="text-muted">شنبه تا چهارشنبه ۹:۰۰ الی ۱۷:۰۰</span>
              </p>
            </div>

            {/* دسترسی سریع */}
            <div className="col-md-3 p-4">
              <p className="bold text-muted">دسترسی سریع</p>
              <hr/>
              {[
                { href: "#agent-pricing", label: "تعرفه عامل ها" },
                { href: "#faq", label: "سوالات متداول" },
                { href: "https://auth.ibinsina.com/?url=https://ibinsina.com", label: "ثبت نام اولیه" },
                { href: "https://panel.ibinsina.com", label: "ورود به پنل های کاربری" },
              ].map((item, idx) => (
                <div key={idx} className="mb-4">
                  <a href={item.href} className="brand-a text-muteds">
                    <span className="m-2 text-primary"><BsSquare/></span>
                    {item.label}
                  </a>
                  
                </div>
              ))}
            </div>

            {/* پیوند های ارتباطی */}
            <div className='col-md-3 p-4'>
              <p className="bold text-muted">پیوند های ارتباطی</p>
              <hr/>
              {[
                { href: 'https://ut.ac.ir', label: "دانشگاه تهران" },
                { href: 'https://iiid.tech', label: "منطقه بین المللی نوآوری ایران" },
                { href: 'https://nlai.ir', label: "سازمان اسناد و کتابخانه ملی ایران" },
                { href: 'https://inif.ir', label: "صندوق نوآوری و شکوفایی ریاست جمهوری" },
                { href: 'https://tehran.irannsr.org/', label: "انجمن صنفی رایانه ای استان تهران" },
              ].map((item, idx) => (
                <div key={idx} className="mb-4">
                  <a href={item.href} className="brand-a text-muted">
                    <span className="m-2 text-primary"><MdChevronLeft/></span>
                    {item.label}
                  </a>
                </div>
              ))}
            </div>

            {/* رسالت */}
            <div className='col-md-3 p-4'>
              <p className="bold text-muted">رسالت ما</p>
              <hr/>
              <p className='brand-p bold'>
                طراحی، توسعه و پایش سامانه ها و مدل های بومی مستقر در زیرساخت داخلی کشور با هدف رشد و ارتقا سطح علمی و مهندسی ایران در زمینه های مرتبط با هوش مصنوعی و علوم داده و مهندسی نرم افزار.
              </p>
              <div className="row justify-content-center">
                <div className="col-3 p-2 text-center">
                  <img className="footer-img" width="50%" src={UtLogo} alt="UT"/>
                </div>
                <div className="col-3 p-2 text-center">
                  <img className="footer-img" width="50%" src={NlLogo} alt="NLA"/>
                </div>
                <div className="col-3 p-2 text-center">
                  <img className="footer-img" width="75%" src={ParkLogo} alt="Park"/>
                </div>
                <div className="col-3 p-2 text-center">
                  <a width="100%" referrerPolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=398202&Code=6D2634awBsgyNzM3ZwZl23gH1WNSHAgF'>
                    <img className="footer-img" referrerPolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=398202&Code=6D2634awBsgyNzM3ZwZl23gH1WNSHAgF' alt='ENAMAD' width="75%" />
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
        <hr/>
        <p className="text-center text-muted brand-p">
          <span className="m-2"><BsCcCircle/></span>
          تمامی حقوق مادی و معنوی این پلتفرم متعلق به شرکت علم و فناوری و خدمات مدیریت ابن سینا می باشد
        </p>
      </div>
    </>
  );
}
